<div id="welcome" class="content receptionist" [attr.data-buildnumber]="buildNumber">
  <div class="image"></div>
  <h1 class="title">
    Welcome to the <span id="trainingCenterName">{{ trainingCenterDisplayName }}</span>
  </h1>
  <h1 class="title">Training Center</h1>

  <div class="actions">
    <button class="start" (click)="next()" [disabled]="isRunningProcess">
      <span class="label">Start</span>
      <i class="icon icon-arrow-right"></i>
    </button>
  </div>

  <div class="buildNumber" (click)="administration()">
    {{ buildNumber }}
  </div>
</div>
